import { React, useState } from "react";
import { Col, Row, Modal, Form, Input, Select, InputNumber } from "antd";
import { PapaParse, CSVLink } from "papaparse";
import {
  CheckCircleFilled,
  edit,
  trash,
  CloseCircleFilled,
} from "../../Utils/imports";
import ButtonComp from "../ButtonComp/ButtonComp";
import { getFromLocalStorage } from "../../Helpers/helpers";
import { useDispatch,useSelector } from 'react-redux';
import { generateId } from "../../Utils/generateId";
import { createPlant, createMachine } from "../../API-Interaction/apiServices/plantSettings.api"
import "./AddPlantModal.css";

const AddPlantModal = ({ open, onClose, title }) => {
  const { current } = useSelector((state) => state.plant);
  let { plant = null } = JSON.parse(localStorage.getItem('current'));
  const [data, setData] = useState([]);
  const [form] = Form.useForm();
  const timeZones = {
    "(GMT-11:00) Pago Pago": "Pacific/Pago_Pago",
    "(GMT-10:00) Hawaii Time": "Pacific/Honolulu",
    "(GMT-08:00) Pacific Time": "America/Los_Angeles",
    "(GMT-08:00) Pacific Time - Tijuana": "America/Tijuana",
    "(GMT-07:00) Mountain Time": "America/Denver",
    "(GMT-07:00) Mountain Time - Arizona": "America/Phoenix",
    "(GMT-07:00) Mountain Time - Chihuahua, Mazatlan": "America/Mazatlan",
    "(GMT-06:00) Central Time": "America/Chicago",
    "(GMT-06:00) Central Time - Mexico City": "America/Mexico_City",
    "(GMT-06:00) Central Time - Regina": "America/Regina",
    "(GMT-06:00) Guatemala": "America/Guatemala",
    "(GMT-05:00) Bogota": "America/Bogota",
    "(GMT-05:00) Eastern Time": "America/New_York",
    "(GMT-05:00) Lima": "America/Lima",
    "(GMT-04:30) Caracas": "America/Caracas",
    "(GMT-04:00) Atlantic Time - Halifax": "America/Halifax",
    "(GMT-04:00) Guyana": "America/Guyana",
    "(GMT-04:00) La Paz": "America/La_Paz",
    "(GMT-03:00) Buenos Aires": "America/Argentina/Buenos_Aires",
    "(GMT-03:00) Godthab": "America/Godthab",
    "(GMT-03:00) Montevideo": "America/Montevideo",
    "(GMT-03:30) Newfoundland Time - St. Johns": "America/St_Johns",
    "(GMT-03:00) Santiago": "America/Santiago",
    "(GMT-02:00) Sao Paulo": "America/Sao_Paulo",
    "(GMT-02:00) South Georgia": "Atlantic/South_Georgia",
    "(GMT-01:00) Azores": "Atlantic/Azores",
    "(GMT-01:00) Cape Verde": "Atlantic/Cape_Verde",
    "(GMT+00:00) Casablanca": "Africa/Casablanca",
    "(GMT+00:00) Dublin": "Europe/Dublin",
    "(GMT+00:00) Lisbon": "Europe/Lisbon",
    "(GMT+00:00) London": "Europe/London",
    "(GMT+00:00) Monrovia": "Africa/Monrovia",
    "(GMT+01:00) Algiers": "Africa/Algiers",
    "(GMT+01:00) Amsterdam": "Europe/Amsterdam",
    "(GMT+01:00) Berlin": "Europe/Berlin",
    "(GMT+01:00) Brussels": "Europe/Brussels",
    "(GMT+01:00) Budapest": "Europe/Budapest",
    "(GMT+01:00) Central European Time - Belgrade": "Europe/Belgrade",
    "(GMT+01:00) Central European Time - Prague": "Europe/Prague",
    "(GMT+01:00) Copenhagen": "Europe/Copenhagen",
    "(GMT+01:00) Madrid": "Europe/Madrid",
    "(GMT+01:00) Paris": "Europe/Paris",
    "(GMT+01:00) Rome": "Europe/Rome",
    "(GMT+01:00) Stockholm": "Europe/Stockholm",
    "(GMT+01:00) Vienna": "Europe/Vienna",
    "(GMT+01:00) Warsaw": "Europe/Warsaw",
    "(GMT+02:00) Athens": "Europe/Athens",
    "(GMT+02:00) Bucharest": "Europe/Bucharest",
    "(GMT+02:00) Cairo": "Africa/Cairo",
    "(GMT+02:00) Jerusalem": "Asia/Jerusalem",
    "(GMT+02:00) Johannesburg": "Africa/Johannesburg",
    "(GMT+02:00) Helsinki": "Europe/Helsinki",
    "(GMT+02:00) Kiev": "Europe/Kiev",
    "(GMT+02:00) Moscow-01 - Kaliningrad": "Europe/Kaliningrad",
    "(GMT+02:00) Riga": "Europe/Riga",
    "(GMT+02:00) Sofia": "Europe/Sofia",
    "(GMT+02:00) Tallinn": "Europe/Tallinn",
    "(GMT+02:00) Vilnius": "Europe/Vilnius",
    "(GMT+03:00) Istanbul": "Europe/Istanbul",
    "(GMT+03:00) Baghdad": "Asia/Baghdad",
    "(GMT+03:00) Nairobi": "Africa/Nairobi",
    "(GMT+03:00) Minsk": "Europe/Minsk",
    "(GMT+03:00) Riyadh": "Asia/Riyadh",
    "(GMT+03:00) Moscow+00 - Moscow": "Europe/Moscow",
    "(GMT+03:30) Tehran": "Asia/Tehran",
    "(GMT+04:00) Baku": "Asia/Baku",
    "(GMT+04:00) Moscow+01 - Samara": "Europe/Samara",
    "(GMT+04:00) Tbilisi": "Asia/Tbilisi",
    "(GMT+04:00) Yerevan": "Asia/Yerevan",
    "(GMT+04:30) Kabul": "Asia/Kabul",
    "(GMT+05:00) Karachi": "Asia/Karachi",
    "(GMT+05:00) Moscow+02 - Yekaterinburg": "Asia/Yekaterinburg",
    "(GMT+05:00) Tashkent": "Asia/Tashkent",
    "(GMT+05:30) Colombo": "Asia/Colombo",
    "(GMT+06:00) Almaty": "Asia/Almaty",
    "(GMT+06:00) Dhaka": "Asia/Dhaka",
    "(GMT+06:30) Rangoon": "Asia/Rangoon",
    "(GMT+07:00) Bangkok": "Asia/Bangkok",
    "(GMT+07:00) Jakarta": "Asia/Jakarta",
    "(GMT+07:00) Moscow+04 - Krasnoyarsk": "Asia/Krasnoyarsk",
    "(GMT+08:00) China Time - Beijing": "Asia/Shanghai",
    "(GMT+08:00) Hong Kong": "Asia/Hong_Kong",
    "(GMT+08:00) Kuala Lumpur": "Asia/Kuala_Lumpur",
    "(GMT+08:00) Moscow+05 - Irkutsk": "Asia/Irkutsk",
    "(GMT+08:00) Singapore": "Asia/Singapore",
    "(GMT+08:00) Taipei": "Asia/Taipei",
    "(GMT+08:00) Ulaanbaatar": "Asia/Ulaanbaatar",
    "(GMT+08:00) Western Time - Perth": "Australia/Perth",
    "(GMT+09:00) Moscow+06 - Yakutsk": "Asia/Yakutsk",
    "(GMT+09:00) Seoul": "Asia/Seoul",
    "(GMT+09:00) Tokyo": "Asia/Tokyo",
    "(GMT+09:30) Central Time - Darwin": "Australia/Darwin",
    "(GMT+10:00) Eastern Time - Brisbane": "Australia/Brisbane",
    "(GMT+10:00) Guam": "Pacific/Guam",
    "(GMT+10:00) Moscow+07 - Magadan": "Asia/Magadan",
    "(GMT+10:00) Moscow+07 - Yuzhno-Sakhalinsk": "Asia/Vladivostok",
    "(GMT+10:00) Port Moresby": "Pacific/Port_Moresby",
    "(GMT+10:30) Central Time - Adelaide": "Australia/Adelaide",
    "(GMT+11:00) Eastern Time - Hobart": "Australia/Hobart",
    "(GMT+11:00) Eastern Time - Melbourne, Sydney": "Australia/Sydney",
    "(GMT+11:00) Guadalcanal": "Pacific/Guadalcanal",
    "(GMT+11:00) Noumea": "Pacific/Noumea",
    "(GMT+12:00) Majuro": "Pacific/Majuro",
    "(GMT+12:00) Moscow+09 - Petropavlovsk-Kamchatskiy": "Asia/Kamchatka",
    "(GMT+13:00) Auckland": "Pacific/Auckland",
    "(GMT+13:00) Fakaofo": "Pacific/Fakaofo",
    "(GMT+13:00) Fiji": "Pacific/Fiji",
    "(GMT+13:00) Tongatapu": "Pacific/Tongatapu",
    "(GMT+14:00) Apia": "Pacific/Apia",
  };
  const dispatch = useDispatch();
  const { Option } = Select;

  const onFinish = async (values) => {
    let currentUser = getFromLocalStorage('user');
    if (title === 'Add Plant') {
      values.productionLines = [];
      values = {...values,alertSettings: [],
        accessControl: [
          {
            email: currentUser.username,
            role: 'admin',
          },
        ],
      plantId:plant?._id
    }

      createPlant('plant', dispatch, values)

    } else if(title === 'Add Line') {

      values.reasons = 'saad';
      values = {...values,
        accessControl: [
          {
            email: currentUser.username,
            role: 'admin',
          },
        ],
        currentPlant: plant,
        plantId:plant?._id,
        plantName: plant?.plantName,
        dayStartAdjustment: { time: '', minus: 0, add: 0 },
        midDayResetAdjustment: { time: '', minus: 0, add: 0 },
        lineSpeed: 0,
        alertSettings: [],
        shifts: [],
        status: {
          status: 'disconnected',
          time: new Date(),
        },
      }
      createPlant('productionLine', dispatch, values)

    } else if(title === 'Add Machine'){

      let machines = current?.line.machines ? [...current.line.machines] : [];
      // if (current?.line.shifts)
      //   values.shifts = current?.line.shifts
      // if (current?.line.plannedStoppages)
      //   values.plannedStoppages = current?.line.plannedStoppages
      // if (current?.line.formulae)
      //   values.formulae = current?.line.formulae
      // if (current?.line.stopTime)
      //   values.stopTime = current?.line.stopTime
      // if (current?.line.targetOee)
      //   values.targetOee = current?.line.targetOee

      // values.machineName = generateId('machine', {slug: values.displayName})
      // machines.push(values)
      // let plannedDowntimes = []
      //   let {line = null} = JSON.parse(localStorage.getItem('current'))
      //   plannedDowntimes = line.plannedDowntimes

    //   current?.line.product.map(x => {
    //       x.machine = values.machineName
    //   })
    //   current?.line.plannedDowntimes.map(x => {
    //     x.machine = values.machineName
    //  })
    //  current?.line.dynamicAdjustments.map(x => {
    //     x.machine = values.machineName
    //  })

    // let params = {
    //   productionLine :{
    //     '_id': current?.line.id,
    //     plantId: current?.plant._id,
    //     machines,
    //     [`${values.machineName} status`]: {
    //       status: 'disconnected',
    //       time: new Date(),
    //   }
    //   },
    //   products,
    //   plannedDowntimes,
    //   dynamicAdjustments,
    //   machine: values.machineName
    // }
      // createMachine(dispatch, params) caaling create machine function
      console.log(machines, values, 'values')
    }
    handleModalClose()
  };

  const handleModalClose = () => {
    onClose();
  };

  const handleChangeFile = (e) => {
    let reader = new FileReader();
    if (e.target.files.length > 0) {
      const filename = e.target.files[0].name;

      reader.onload = (event) => {
        const csvData = PapaParse.parse(
          event.target.result,
          Object.assign(
            {},
            {
              error: (err) => alert(err),
              encoding: "UTF-8",
            }
          )
        );
        parseCsvData(csvData.data);
        setData({ filename });
      };

      reader.readAsText(e.target.files[0], "UTF-8");
    }
  };
  const parseCsvData = (data) => {
    try {
      data.splice(0, 1);
      let dict = {};
      for (let obj of data) {
        csvToJson(obj, dict, 0);
      }
      setData({ reasons: dict });
    } catch (err) {
      alert(err);
    }
  };
  const csvToJson = (arr, obj, i) => {
    if (i == arr.length - 1) {
      if (Array.isArray(obj)) {
        obj.push(arr[i]);
        return obj;
      } else return [arr[i]];
    } else {
      if (arr[i] == "-" || arr[i] == "") {
        return this.csvToJson(arr, obj, i + 1);
      } else {
        if (obj[arr[i]] == null) {
          obj[arr[i]] = {};
        }
        obj[arr[i]] = csvToJson(arr, obj[arr[i]], i + 1);
        return obj;
      }
    }
  };

  return (
    <div>
      <Modal
        title={<h2>{title}</h2>}
        centered
        maskClosable={false}
        footer={null}
        className="AddPlantModal"
        open={open}
        onCancel={handleModalClose}
      >
        <Form
          form={form}
          name="addPlantForm"
          className="addPlantForm"
          labelCol={{
            span: 8,
          }}
          wrapperCol={{
            span: 24,
          }}
          initialValues={{
            remember: false,
          }}
          onFinish={onFinish}
          // onFinishFailed={onFinishFailed}
          autoComplete="off"
        >
          <h4>Name</h4>
          <Form.Item
          name={title === 'Add Plant' ? "plantName" : title === 'Add Line' ? "lineName" : "displayName"}

            rules={[
              {
                required: true,
                message: "Please Enter Name!",
              },
            ]}
          >
            <Input
              className="boxBorderRad width100P"
              placeholder={"Enter Name"}
            />
          </Form.Item>
          {title === "Add Plant" ? (
           <div>
           <h4>Timezone</h4>
           <Form.Item name="timezone">
             <Select showSearch placeholder="Select timezone">
               {Object.keys(timeZones).map((zone) => (
                 <Option key={timeZones[zone]} value={timeZones[zone]}>
                   {`${zone}`}
                 </Option>
               ))}
             </Select>
           </Form.Item>
         </div>
          ) : title === "Add Line" ? (
            <div>
              <h4>Hall Name</h4>
              <Form.Item
                name="hallName"
                rules={[
                  {
                    required: true,
                    message: "Please enter Hall Name!",
                  },
                ]}
              >
                <Input
                  className="boxBorderRad width100P"
                  placeholder="Enter Hall Name"
                />
              </Form.Item>
            </div>
          ) : null}
          {title !== 'Add Plant' ? (
            <div>
              <label style={{fontWeight: 'bold', textTransform: 'uppercase', fontSize: '14px'}}>Import Reasons</label>
              <Form.Item name="reasons">
                <div style={{textAlign: 'center', marginTop: '10px'}}>
                <label for="SelectFIle" className="importReasons">
                  Import CSV{" "}
                </label>
                <input
                  theme={"white"}
                  type="file"
                  size="30"
                  id="SelectFIle"
                  onChange={(e) => handleChangeFile(e)}
                  accept=".csv, text/csv"
                  style={{ display: "none" }}
                />
                </div>
              </Form.Item>
            </div>
          ) : null}
          <Row className="dflex alignCenter justifyCenter gap10">
            <Form.Item>
              <ButtonComp
                style={{ width: "150px" }}
                theme={"blue"}
                htmlType="submit"
                text={"Save"}
                icon={<CheckCircleFilled />}
              />
            </Form.Item>
            <Form.Item>
              <ButtonComp
                style={{ width: "150px" }}
                theme={"red"}
                text={"Cancel"}
                icon={<CloseCircleFilled />}
                onClick={handleModalClose}
              />
            </Form.Item>
          </Row>
        </Form>
      </Modal>
    </div>
  );
};
export default AddPlantModal;
